import { Grid, Tab, Tabs } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export const DailyOverviewTabs = ({
  tab,
  setTab
}: {
  tab: string;
  setTab: (tab: string) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Tabs value={tab} onChange={(_event, value) => setTab(value)}>
        <Tab label={t(translations.pages.leihbar.daily.tabs.pickups())} value={'pickups'} />
        <Tab label={t(translations.pages.leihbar.daily.tabs.returns())} value={'returns'} />
      </Tabs>
    </Grid>
  );
};
